import { useContext } from 'react';
import { AUTHContext } from '../providers/AUTHProvider';

function useAUTH() {
  const { makeTokenInvalid, tokenInvalid } = useContext(AUTHContext);
  return { makeTokenInvalid, tokenInvalid };
}

export default useAUTH;